import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup.object().shape({
    industry: yup.object().required(
      formatMessage({
        id: 'INDUSTRY_IS_REQUIRED',
        defaultMessage: 'Industry is required',
      }),
    ),
    address: yup.string().required(
      formatMessage({
        id: 'ADDRESS_IS_REQUIRED',
        defaultMessage: 'Address is required',
      }),
    ),
    problem: yup.string().nullable(),
  });

export default validationSchema;
